import Main from '@/views/Main.vue';
import i18n from "../language/index";


// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: i18n.tc('l.login')
    },
    component: () => import('@/views/login.vue')
};

// 密码过于简单 重设密码页面
export const setPwdRouter = {
    path: '/set_pwd_page',
    name: 'set_pwd_page',
    meta: {
        title: i18n.tc('l.set_pwd')
    },
    component: () => import('@/views/set_pwd_page.vue')
};


// 设置手机号
export const setMobileRouter = {
    path: '/set_mobile_page',
    name: 'set_mobile_page',
    meta: {
        title: "完善手机号"
    },
    component: () => import('@/views/set_mobile_page.vue')
};

export const loginMobileRouter = {
    path: '/m_login',
    name: 'm_login',
    meta: {
        title: i18n.tc('l.login')
    },
    component: () => import('@/views/m_login.vue')
};

export const homeMobileRouter = {
    path: '/m_home',
    name: 'm_home',
    meta: {
        title: i18n.tc('l.home')
    },
    component: () => import('@/views/home/m_home.vue')
};

// 手机版监控界面
export const monitorMobileRouter = {
    path: '/m_monitor/:id',
    name: 'm_monitor',
    meta: {
        title: i18n.tc('l.monitor')
    },
    component: () => import('@/views/device/m_monitor.vue')
};

export const mainRouter =  {
    path: '',
    redirect: '/home',
    name: 'otherRouter',
    component: Main,
    children: [
        {
            path: 'home',
            title: {i18n: 'home'},
            meta: {
                type: 'home',
            },
            name: 'home_index',
            component: () => import('@/views/home/home.vue')
        },
        {
            path: 'explain',
            title: i18n.tc('l.explain'),
            meta: {
                type: 'explain',
            },
            name: 'explain',
            component: () => import('@/views/instructions/explain.vue')
        }
    ]
};

export const monitorRouter = {
    path: '/monitor',
    name: 'monitor1',
    meta: {
        title: i18n.tc('l.monitor')
    },
    component: () => import('@/views/device/page-lift-monitor.vue')
};

export const page404 = {
    path: '/*',
    name: 'error-404',
    meta: {
        type: 'error',
        title: i18n.tc('l.err_404')
    },
    component: () => import('@/views/error-page/404.vue')
};

export const pageNetError = {
    path: '/*',
    name: 'error-net',
    meta: {
        type: 'error',
        title: i18n.tc('l.err_net')
    },
    component: () => import('@/views/error-page/net-error.vue')
};

export const page403 = {
    path: '/403',
    meta: {
        type: 'error',
        title: i18n.tc('l.err_403')
    },
    name: 'error-403',
    component: () => import('@//views/error-page/403.vue')
};

export const page500 = {
    path: '/500',
    meta: {
        type: 'error',
        title: i18n.tc('l.err_500')
    },
    name: 'error-500',
    component: () => import('@/views/error-page/500.vue')
};

//  用户页面路由
const userRouterItem = {
    path: '/system',
    name: 'menu_system',
    title: "l.system_manage",
    component: Main,
    children: [
        // {
        //     path: 'user',
        //     name: 'page_user',
        //     title: 'l.user_manage',
        //     component: (resolve) => require(['@/views/sys/page-user'],resolve)
        // },
        {
            path: 'user',
            name: 'page_user',
            title: 'l.user_manage',
            component: (resolve) => require(['@/views/sys/page-new-user'],resolve)
        },
        // {
        //     path: 'payaccount',
        //     name: 'page_pay_account',
        //     title: 'l.pay_account',
        //     component: (resolve) => require(['@/views/sys/page-pay-account'],resolve)
        // },
        {
            path: 'community',
            name: 'page_community',
            title: 'l.community_manage',
            component: (resolve) => require(['@/views/sys/page-community'],resolve)
        },
        {
            path: 'settings',
            name: 'page_settings',
            title: 'l.system_setting',
            component: (resolve) => require(['@/views/sys/page-settings'],resolve)
        },
        // 2025年8月8日 王欢  按照柳 要求 新增推送配置账号查看列表
        {
            path: 'pusher_account',  //
            name: 'page_pusher_account',
            title: 'l.pusher_account',
            component: (resolve) => require(['@/views/sys/page-pusher-account'],resolve)
        },
    ]
};
//  设备管理
const deviceRouterItem = {
    path: '/device',
    name: 'menu_device',
    title: 'l.device_manage',
    component: Main,
    children: [
        {
            path: 'list',
            name: 'page_device',
            title: 'l.device_list',
            component: (resolve) => require(['@/views/device/page-device'],resolve)
        },
        // {
        //     path: 'maintain',
        //     name: 'page_maintain',
        //     title: 'l.maintain_list',
        //     component: (resolve) => require(['@/views/device/page-maintain'],resolve)
        // },
        {
            path: 'remove_list',
            name: 'page_remove_device',
            title: 'l.remove_device_list',
            component: (resolve) => require(['@/views/device/page_remove_device'],resolve)
        },
        {
            path: 'end_time_list',
            name: 'page-device-end-time',
            title: 'l.end_time_device_list',
            component: (resolve) => require(['@/views/device/page-device-end-time'],resolve)
        },
        {
            path: 'terminal',
            name: 'page_terminal',
            title: 'l.terminal_list',
            component: (resolve) => require(['@/views/device/page-terminal'],resolve)
        },
        // {
        //     path: 'aed_fault',
        //     name: 'page-aed-fault',
        //     title: 'l.aed_fault_list',
        //     component: (resolve) => require(['@/views/device/page-aed-fault'],resolve)
        // },
        // {
        //     path: 'aed',
        //     name: 'page-aed',
        //     title: 'l.aed_list',
        //     component: (resolve) => require(['@/views/device/page-aed'],resolve)
        // },
        {
            path: 'fault',
            name: 'page_fault',
            title: 'l.fault_list',
            component: (resolve) => require(['@/views/device/page-fault'],resolve)
        },
        // {
        //     path: 'event',
        //     name: 'page_event',
        //     title: 'l.event_list',
        //     component: (resolve) => require(['@/views/device/page-event'],resolve)
        // },
        {
            path: 'sim',
            name: 'page_sim',
            title: 'l.sim_list',
            component: (resolve) => require(['@/views/device/page-sim'],resolve)
        },
        {
            path: 'monitor/:id',
            name: 'page_lift_monitor',
            title: 'l.monitor',
            meta: {
                hidden: true
            },
            component: (resolve) => require(['@/views/device/page-lift-monitor'],resolve)
        },
        // 2025年6月19日 王欢 删除此功能  葛拉瑞不合作了
        // {
        //     path: 'parts_warn',
        //     name: 'device_parts_warn',
        //     title: 'l.warn_monitor',
        //     component: (resolve) => require(['@/views/device/page-device-parts-warn'],resolve)
        // },

    ]
};
//  电梯页面路由

//  开发人员
const apiRouterItem = {
    path: '/dev',
    icon: 'arrow-swap',
    name: 'menu_api',
    title: 'l.development',
    component: Main,
    children: [
        {
            path: 'res',
            name: 'page_res',
            title: 'l.res_manage',
            component: (resolve) => require(['@/views/develop/page-res'],resolve)
        },{
            path: 'exception',
            name: 'page_exception',
            title: 'l.server_exception',
            component: (resolve) => require(['@/views/develop/page-exception'],resolve)
        },
        {
            path: 'terminal_exception',
            name: 'page_terminal_exception',
            title: 'l.terminal_exception',
            component: (resolve) => require(['@/views/develop/page_terminal_exception'],resolve)
        },
        {
            path: 'app_crash_log',
            name: 'page_crash_log',
            title: 'l.crash_log',
            component: (resolve) => require(['@/views/develop/page_crash_log'],resolve)
        },
        // {
        //     path: 'massager',
        //     name: 'page_messager',
        //     title: '消息测试',
        //     component: (resolve) => require(['@/views/develop/message-send-receive'],resolve)
        // }
    ]
};

//  乘梯管理
const apiRouterOwner = {
    path: '/control',
    icon: 'arrow-swap',
    name: 'menu_control',
    title: 'l.take_ladder_manage',
    component: Main,
    children: [
        {
            path: 'owner',
            name: 'page_owner',
            title: 'l.owner_manage',
            component: (resolve) => require(['@/views/sys/page_owner'],resolve)
        }
        ,
        {
            path: 'keys',
            name: 'page_keys',
            title: 'l.deleted_key',
            component: (resolve) => require(['@/views/sys/page_keys'],resolve)
        }
    ]
};

const dtzjRouterItem = {
    path: '/dtzj',
    name: 'menu_dtzj',
    title: "l.menu_dtzj",
    component: Main,
    children: [
        {
            path: 'version',
            name: 'page_version',
            title: 'l.version_manage',
            component: (resolve) => require(['@/views/dtzj/page-version'],resolve)
        },
        {
            path: 'data',
            name: 'page_data',
            title: 'l.data_manage',
            component: (resolve) => require(['@/views/dtzj/page-data'],resolve)
        },
        {
            path: 'logs',
            name: 'page_active_logs',
            title: 'l.logs_manage',
            component: (resolve) => require(['@/views/dtzj/page-active-log.vue'],resolve)
        },
    ]
};


// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
    userRouterItem,
    apiRouterOwner,
    deviceRouterItem,
    // liftRouterItem,
    apiRouterItem,
    dtzjRouterItem
    // explainRouterItem
];

//  产品说明书
const wxQrItem = {
    path: '/wx/qr',
    name: 'wx_qr',
    meta: {
        title: i18n.tc('l.product_manual')
    },
    component:  () => import('@/views/wx/page-qr.vue')
};

// 微信服务号路由
export const wxRouter = [
    wxQrItem,
];

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    ...wxRouter,
    mainRouter,
    loginRouter,
    setPwdRouter,
    setMobileRouter,
    loginMobileRouter,
    homeMobileRouter,
    monitorMobileRouter,
    monitorRouter,
    ...appRouter,
    page500,
    page403,
    page404,
    pageNetError
];

function setRouterTitle(routerList) {
    routerList.forEach(route => {
        if (route.title) {
            if (!route.meta) route.meta = {title: route.title};
            else route.meta.title = route.title;
        }
        if (route.children) setRouterTitle(route.children);
    })
}

setRouterTitle(routers);
